import React, { useState } from "react";
import styled from "styled-components/macro";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { StyledBlackButton } from "../../ButtonsStyle";
import { questionsWizard, titleWizard } from "./questionsWizard";

const WizardUnitStep3 = ({
  onClick,
  onBackPress,
  propertySize,
  propertyKey,
}) => {
  const properties = questionsWizard.propertySize[propertyKey];
  const title = titleWizard.propertySize[propertyKey];

  const [property, setProperty] = useState(
    propertySize
      ? properties.findIndex((e) => e.title === propertySize.title)
      : -1
  );

  const _renderProperties = () => {
    return properties.map((item, index) => {
      return (
        <Section
          index={index}
          className={`animate__animated animate__fadeIn`}
          onClick={() => setProperty(index)}
          key={item.title}
        >
          <img
            height={150}
            src={property === index ? item.chosen : item.image}
            alt={"residential"}
          />
          <Title style={{ marginTop: "5px" }} fontSize={20}>
            {item.title.toUpperCase()}
          </Title>
          <Radio>{property === index && <InnerRadio />}</Radio>
        </Section>
      );
    });
  };

  return (
    <Wrapper>
      <TitleWrapper>
        <div
          onClick={onBackPress}
          style={{ padding: "10px 20px", cursor: "pointer" }}
        >
          <FontAwesomeIcon size={"lg"} color={"#4b4b4b"} icon={faArrowLeft} />
        </div>
        <Title fontSize={35}>{title}</Title>
      </TitleWrapper>
      <ImagesWrapper>{_renderProperties()}</ImagesWrapper>

      <StyledBlackButton
        disabled={property === -1}
        onClick={() => onClick(properties[property])}
        style={{
          marginTop: "40px",
          backgroundColor: property === -1 ? "#a1a0a0" : "#606060",
          color: "#FFFFFF",
          fontSize: "20px",
          fontFamily: " Manrope,serif",
          padding: "10px 40px",
        }}
      >
        Next
      </StyledBlackButton>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  align-items: center;
  justify-content: center;
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 20px;
`;

const Radio = styled.div`
  align-items: center;
  justify-content: center;
  position: relative;
  display: flex;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  padding: 4px;
  border: 1px solid #13647b;
`;

const InnerRadio = styled.div`
  position: relative;
  display: flex;
  width: 100%;
  height: 100%;
  background-color: #13647b;
  border-radius: 50%;
`;

const Section = styled.div`
  cursor: pointer;
  align-items: center;
  justify-content: center;
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 10px 10px;
  animation-delay: ${({ index }) => 60 * index}ms;
  width: 300px;
`;

const ImagesWrapper = styled.div`
  align-items: start;
  justify-content: center;
  position: relative;
  flex-direction: row;
  display: grid;
  grid-template-columns: 1fr 1fr;
`;

const Title = styled.div`
  padding: 10px 0;
  color: ${({ color = "#4b4b4b" }) => color};
  font-size: ${({ fontSize = 50 }) => fontSize}px;
  white-space: pre-wrap;
  text-align: center;
  font-family: Manrope, serif;
`;
const TitleWrapper = styled.div`
  display: flex;
  position: relative;
  align-items: center;
`;
export { WizardUnitStep3 };
